import type { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import type { BaseProps, ForwardProps } from '../../types';
import { defaultThemeProp } from '../../theme';

export interface ParagraphSkeletonProps extends BaseProps {
  /** Children for the skeleton. These should be Line and Rectangle Skeletons. */
  children: ReactNode;
}

const defaultProps: Partial<ParagraphSkeletonProps> = {};

const StyledParagraphSkeleton = styled.div<ParagraphSkeletonProps>`
  margin: 0.25rem 0;
`;

StyledParagraphSkeleton.defaultProps = defaultThemeProp;

const ParagraphSkeleton: FunctionComponent<ParagraphSkeletonProps & ForwardProps> = ({
  children,
  ...restProps
}: ParagraphSkeletonProps) => {
  return (
    <StyledParagraphSkeleton {...restProps} aria-disabled>
      {children}
    </StyledParagraphSkeleton>
  );
};

ParagraphSkeleton.defaultProps = defaultProps;

export default ParagraphSkeleton;
